import { IntegrationConfig } from 'modules/Integrations/domain'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import logo from './netsuiteLogo.svg'
import { NetsuiteIntegrationDetail } from './NetsuiteIntegrationDetail/NetsuiteIntegrationDetail'
import { NetsuiteConfigurationManagement } from './NetsuiteConfigurationManagement/NetsuiteConfigurationManagement'
import { netsuiteConfigurationLoader } from './netsuite.loader'
import { netsuiteConfigurationMutator } from './netsuite.mutator'

export const netsuiteIntegrationConfig: IntegrationConfig = {
  logoUrl: logo,
  smallLogoUrl: logo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/netsuite',
  title: 'NetSuite',
  features: {
    canDeleteLinks: false,
    canUninstall: false,
    isDocumentationOnly: false,
    disableSubmitUntilValid: true
  },
  description:
    'Sync Sequence customers, invoices, and credit notes to NetSuite in real time.',
  components: {
    detail: NetsuiteIntegrationDetail,
    management: NetsuiteConfigurationManagement
  },
  communication: {
    configuration: {
      loader: netsuiteConfigurationLoader,
      mutator: netsuiteConfigurationMutator
    }
  }
}

// privateKey is write-only: never returned by the loader, always '' on load.
export type NetsuiteAuthenticationFields = {
  netsuiteAccountId: string
  consumerKey: string
  certificateId: string
  privateKey: string
}

// The values PUT /integrations/netsuite/settings accepts. The item ids are
// optional and each is '' when NetSuite has no item mapped.
export type NetsuiteSettingsFields = {
  subsidiaryId: string
  defaultItemIncomeAccountId: string
  defaultTaxScheduleId: string
  prepaidCreditItemId: string
  commitmentItemId: string
  creditGrantItemId: string
  salesTaxItemId: string
  deferredRevenueItemId: string
}

// The subset of the settings the credentials test endpoint validates.
export type NetsuiteTestedSettings = Pick<
  NetsuiteSettingsFields,
  'subsidiaryId' | 'defaultItemIncomeAccountId' | 'defaultTaxScheduleId'
>

export type NetsuiteIntegrationConfig = NetsuiteAuthenticationFields &
  NetsuiteSettingsFields & {
    // Comes from the loader rather than the form, and decides where a save
    // goes: the settings endpoint 404s until an integration is connected.
    isConnected: boolean
    /** Push unlinked customers to NetSuite when an invoice is finalised or sent. */
    autoLinkCustomers: boolean
    /** Resolved sync permission for the auto-link toggle (read-only, for the paused state). */
    autoLinkSyncPermission?: Dashboardv99990101Api.GetEntityTypeSyncToggles.SyncPermission
  }
